import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { UserProfileMenuButtonProps } from './UserProfileMenuButton';

const UserProfileMenuButton = () =>
  import(/* webpackChunkName: "4-feat-userprofile-menubutton" */ './UserProfileMenuButton');

const LoadableUserProfileMenuButton: ComponentType<UserProfileMenuButtonProps> = lazyLoadOnRender({
  loader: UserProfileMenuButton,
});
export default LoadableUserProfileMenuButton;
